module.exports = __webpack_public_path__ + "static/RoadmapBot1-63f0e26a7f04dd7e754d10c700fed583.png";